module.exports = __webpack_public_path__ + "img/1294068639.86d3df45.jpg";